import Utility from "../../../utility/utility";
import AppData from "../../public/const/app_data";
import AppController from "../../../sdk/app_controller";
import ModelData from "../../public/model_data";
import ClubNotice from "./clubnotice_module";

const { ccclass, property } = cc._decorator;


@ccclass
export class ClubNoticeEvent extends cc.Component {

    clubId
    userClubId
    module: ClubNotice;
    clickme(a, b) {
        cc.log("=======", a, b)
    }
    clickUrl(event, url) {
        if (url.indexOf("http") > -1) {
            cc.sys.openURL(url)
        } else {
            cc.log("error url")
        }
    }
    clickUrlInfo(event, url) {
        if (url.indexOf("http") > -1) {
            cc.sys.openURL(url + "?inviteCode=" + ModelData.instance.roleData.id + "&clubId=" + this.clubId)
        } else {
            cc.log("error url")
        }// "?inviteCode=" + ModelData.instance.roleData.id + "&clubId=" + self.clubId
    }
    //ios 需要传入facabookid，Facebook id 根据这个页面查询 https://findmyfbid.com/             bigwingame
    clickFacebook(event, param: string) {
        let facebookId
        let facebookHost
        if (param.indexOf(',') > -1) {
            facebookId = param.split(",")[1]
            facebookHost = param.split(",")[0]
        } else {
            facebookHost = param
        }
        AppController.instance.openFacebookUrl(`https://www.facebook.com/${facebookHost}`, facebookId)

    }
    clickLine(event, lineID) {
        // line://ti/p/@238hjrcl
        AppController.instance.openLineChat(lineID)
    }

    clickShop(event, param) {
        this._get_http(function (data) {
            let url = `${param}/?language=${AppData.testMode ? "zh-CN" : "th-TH"}&encryptCode=${data.encryptCode}`
            cc.sys.openURL(url)
        })
    }
    private _get_http(success, fail?) {
        let requestData = {
            baseUrl: "commons/getEncrypt?",
            params: {
                userClubId: this.userClubId
            },
            showNetPrompt: true
        }
        this.module.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail && fail(retData)
        })
    }

}
